<template>
  <img
    :src="iconUrl"
    alt="koppla Logo"
    :width="width"
    :height="height"
    :style="{ width: `${width}px`, height: `${height}px` }"
  />
</template>

<script setup lang="ts">
defineProps({
  /** The height of the icon */
  height: {
    type: String,
    default: '',
  },
  /** The width of the icon */
  width: {
    type: String,
    default: '',
  },
  /** The icon URL */
  iconUrl: {
    type: String,
    default: '',
  },
});
</script>
